import $ from 'jquery';

export function removeFocusAfterClick(element) {
  element.on('mouseup', blurTarget);
  element.on('touchend', blurTarget);
}

function blurTarget() {
  $(this).blur();
}
